import { fetchPublishTerms } from '../../../repositories/billing-tariffs/v1/publish-terms';
import { THeaders } from '../../../types/request';
import { mappers } from './mappers';
import { IGetPublishTermsParams, TGetPublishTermsResult } from './types';

export async function getPublishTerms(params: IGetPublishTermsParams): Promise<TGetPublishTermsResult> {
  const { httpApi, logger, parameters } = params;

  const headers: THeaders = [['Content-Type', 'application/json']];

  const config = {
    requestConfig: { headers },
  };

  try {
    const response = await fetchPublishTerms({
      httpApi,
      parameters,
      config,
      mappers,
    });

    return response as TGetPublishTermsResult;
  } catch (error) {
    logger.error(error, {
      description: 'Запрос publish-terms на Форме подачи',
      degradation: 'Форма выбора услуг на ФП не отобразилась пользователю',
    });
  }

  return {
    success: false,
    payload: 'Ошибка на сервере',
  };
}
